<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="insights"
      :search="search"
      class="elevation-1"
      :pagination.sync="pagination"
      :loading="spinner"
      hide-actions
    >
      <template
        slot="headerCell"
        slot-scope="props"
      >
          <span>
            {{ props.header.text }}
          </span>
      </template>
      <v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>
      <template slot="items" slot-scope="props">
        <tr>
          <td
            v-for="(item, i) in headers"
            :key="i"
            :class="item.class"
          >
            <span v-if="insights[props.index][item.value]">{{ getFilter(props.item[item.value], item.filter) }}</span>
            <span v-else>-</span>
          </td>
        </tr>
      </template>
      <template slot="footer" v-if="total">
        <td class="font-weight-bold">Total</td>
        <td v-if="campaignTypeColumn"></td>
        <td class="text-xs-right font-weight-bold"
            v-for="(insight, index) in totalArray"
            :key="index"
        >
          {{ insight }}
        </td>
      </template>
    </v-data-table>
    <div class="text-xs-center pt-2">
      <v-pagination v-model="pagination.page" :length="pages"/>
    </div>
  </div>
</template>

<script>
import helpers from '../../../helpers/functions'
export default {
  name: 'ReportsInsightsDataTable',
  data () {
    return {
      selected: [],
      pagination: {
        sortBy: 'spend',
        descending: true
      },
      headers: [
        { text: '', align: 'left', value: 'campaign_name', class: 'text-xs-left' },
        { text: 'Campaign Type', align: 'right', value: 'adlabels', class: 'text-xs-right', filter: 'campaignType' },
        { text: 'Budget Spent', align: 'right', value: 'spend', class: 'text-xs-right', filter: 'currency' },
        { text: 'Reach', align: 'right', value: 'reach', class: 'text-xs-right', filter: 'thousands' },
        { text: 'Actions', align: 'right', value: 'total_actions', class: 'text-xs-right', filter: 'thousands' },
        { text: 'Cost per Action', align: 'right', value: 'cost_per_total_action', class: 'text-xs-right', filter: 'currency' },
        { text: 'Clicks', align: 'right', value: 'clicks', class: 'text-xs-right', filter: 'thousands' },
        { text: 'Cost per Click', align: 'right', value: 'cpc', class: 'text-xs-right', filter: 'currency' },
        { text: 'Impressions', align: 'right', value: 'impressions', class: 'text-xs-right', filter: 'thousands' },
        { text: 'CPM', align: 'right', value: 'cpm', class: 'text-xs-right', filter: 'currency' },
        { text: 'CTR', align: 'right', value: 'ctr', class: 'text-xs-right', filter: 'percent' }
      ]
    }
  },
  props: {
    insights: {
      type: Array,
      default: () => []
    },
    firstColumn: {
      type: Object,
      default: () => {}
    },
    campaignTypeColumn: {
      type: Boolean,
      default: true
    },
    search: {
      type: String,
      default: ''
    }
  },
  created () {
    Object.assign(this.headers[0], this.firstColumn)
    if (!this.campaignTypeColumn) this.headers.splice(1, 1)
  },
  computed: {
    pages () {
      if (this.pagination.rowsPerPage == null ||
        this.pagination.totalItems == null
      ) return 0
      return Math.ceil(this.insights.length / this.pagination.rowsPerPage)
    },
    spinner () {
      return this.$store.getters.getSpinner
    },
    total () {
      if (!this.insights.length) return false
      return helpers.countTotal(this.insights)
    },
    totalArray () {
      let arr = []
      this.headers.forEach((h, index) => {
        if (index === 0) return false
        if (this.campaignTypeColumn && index === 1) return false
        const key = h.value
        if (this.total[key]) arr.push(this.getFilter(this.total[key], h.filter))
        else arr.push('-')
      })
      return arr
    }
  },
  methods: {
    getFilter (number, filter) {
      if (filter === 'thousands') {
        return Number(number).toLocaleString()
      } else if (filter === 'currency') {
        return '$' + parseFloat(number).toFixed(2)
      } else if (filter === 'percent') {
        return parseFloat(number).toFixed(1) + '%'
      } else if (filter === 'campaignType') {
        return number.substr(3)
      } else return number
    }
  }
}
</script>
